import React from 'react';
import { Phone, Mail, MapPin, Clock, MessageCircle } from 'lucide-react';
import { contactInfo } from '../data/mock';

const Contact = () => {
  const handleWhatsApp = () => {
    const message = encodeURIComponent('Hi, I would like to know more about medical tourism services.');
    window.open(`https://wa.me/${contactInfo.whatsapp.replace(/[^0-9]/g, '')}?text=${message}`, '_blank');
  };

  return (
    <section className="section-padding" style={{ background: 'var(--bg-page)' }}>
      <div className="container">
        <div className="text-center mb-12">
          <h2 className="heading-1 mb-4">Get in Touch</h2>
          <p className="body-large" style={{ color: 'var(--text-secondary)' }}>
            Have questions? Our team is here to help you 24/7
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          <div className="voice-card accent-blue">
            <div 
              className="w-12 h-12 rounded-full flex items-center justify-center mb-4"
              style={{ background: 'rgba(255, 255, 255, 0.5)' }}
            >
              <Phone size={24} style={{ color: 'var(--text-primary)' }} />
            </div>
            <h3 className="heading-3 mb-2">Phone</h3>
            <a 
              href={`tel:${contactInfo.phone}`}
              className="body-small hover:opacity-70 transition-opacity"
              style={{ color: 'var(--text-secondary)' }}
            >
              {contactInfo.phone}
            </a>
          </div>

          <div className="voice-card accent-purple">
            <div 
              className="w-12 h-12 rounded-full flex items-center justify-center mb-4"
              style={{ background: 'rgba(255, 255, 255, 0.5)' }}
            >
              <MessageCircle size={24} style={{ color: 'var(--text-primary)' }} />
            </div>
            <h3 className="heading-3 mb-2">WhatsApp</h3>
            <button 
              onClick={handleWhatsApp}
              className="body-small hover:opacity-70 transition-opacity text-left"
              style={{ color: 'var(--text-secondary)' }}
            >
              {contactInfo.whatsapp}
            </button>
          </div>

          <div className="voice-card accent-orange">
            <div 
              className="w-12 h-12 rounded-full flex items-center justify-center mb-4"
              style={{ background: 'rgba(255, 255, 255, 0.5)' }}
            >
              <Mail size={24} style={{ color: 'var(--text-primary)' }} />
            </div>
            <h3 className="heading-3 mb-2">Email</h3>
            <a 
              href={`mailto:${contactInfo.email}`}
              className="body-small hover:opacity-70 transition-opacity"
              style={{ color: 'var(--text-secondary)' }}
            >
              {contactInfo.email}
            </a>
          </div>

          <div className="voice-card accent-pink">
            <div 
              className="w-12 h-12 rounded-full flex items-center justify-center mb-4"
              style={{ background: 'rgba(255, 255, 255, 0.5)' }}
            >
              <Clock size={24} style={{ color: 'var(--text-primary)' }} />
            </div>
            <h3 className="heading-3 mb-2">Availability</h3>
            <p className="body-small" style={{ color: 'var(--text-secondary)' }}>
              {contactInfo.hours}
            </p>
          </div>
        </div>

        <div className="mt-8 max-w-2xl mx-auto">
          <div 
            className="voice-card accent-grey"
            style={{ padding: '2rem' }}
          >
            <div className="flex items-start gap-4">
              <div 
                className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0"
                style={{ background: 'rgba(255, 255, 255, 0.5)' }}
              >
                <MapPin size={24} style={{ color: 'var(--text-primary)' }} />
              </div>
              <div>
                <h3 className="heading-3 mb-2">Our Office</h3>
                <p className="body-small" style={{ color: 'var(--text-secondary)' }}>
                  {contactInfo.address}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;